produtos.component('produtos.conteudosComponent', {
    templateUrl: 'produtos/produtoDetalhes/conteudos/conteudos.html',
    controller: 'produtos.conteudosController',
    controllerAs: '$ctrl',
    bindings: { baseProduto: '<' }
});

produtos.controller('produtos.conteudosController', ['$scope', '$element', '$state', '$filter', 'coreToast', 'coreFb', 'coreLanguage', function ($scope, $element, $state, $filter, $toast, $fb, $text) {
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl.sessoes = [];
    $ctrl.modulos = [];
    $ctrl.aulas = [];

    $ctrl.selected = {};

    const _getConteudos=()=>{
        $fb.db.list(`${$ctrl.baseProduto.path}/sessoes`).then(list=>{
            $ctrl.sessoes = $filter('orderBy')(list, 'data.ordem');
            if(!$ctrl.selected.sessao && $ctrl.sessoes.length){ $ctrl.selected.sessao = $ctrl.sessoes[0].id; }

            $ctrl.cfgModulo.options = $ctrl.sessoes;

            return $fb.db.list(`${$ctrl.baseProduto.path}/modulos`);

        }).then(modList=>{
            $ctrl.modulos = $filter('orderBy')(modList, 'data.ordem');
            
            let filteredModulos = $filter('filter')($ctrl.modulos, {data:{idSessao:$ctrl.selected.sessao}})
            
            if(!$ctrl.selected.modulo && ($ctrl.modulos.length && filteredModulos.length)){ 
                $ctrl.selected.modulo = filteredModulos[0].id;
            }

        });

    };

    const _getAulas=()=>{
        $ctrl.loadingAulas= true;

        if(!$ctrl.selected.modulo){
            return;
        }

        $fb.db.list(`${$ctrl.baseProduto.path}/modulos/${$ctrl.selected.modulo}/aulas`)
        .then(list=>{
            $ctrl.aulas = $filter('orderBy')(list, 'data.ordem');
            $ctrl.loadingAulas=false;
        });
    };

    const _confirmSessao=(sessao)=>{

        const __atualizaSessao=()=>{
            $toast.success($text.updateSuccess);

            $ctrl.cfgSessao.dados = {};
            $ctrl.cfgSessao.show = false;

            _getConteudos();
        };

        let obj = {
            nome: sessao.nome,
            ordem: sessao.ordem || 1,
            label: sessao.label || null,
            subtitulo: sessao.subtitulo || null
        };

        if(sessao.path){
            $fb.db.update(`${sessao.path}`, obj).then(()=>{
                __atualizaSessao();
            });

        }else{
            $fb.db.add(`${$ctrl.baseProduto.path}/sessoes`, obj).then(()=>{
                __atualizaSessao();
            });
        }
    };

    const _deleteSessao=()=>{
        $fb.db.del(`${$ctrl.cfgSessao.dados.path}`).then(()=>{
            $toast.success($text.updateSuccess);

            $ctrl.cfgSessao.dados = {};
            $ctrl.cfgSessao.show = false;

            _getConteudos();
        });
    };
    
    const _confirmModulo=(modulo)=>{
        
        const __atualizaModulo=()=>{
            $toast.success($text.updateSuccess);

            $ctrl.cfgModulo.dados = {};
            $ctrl.cfgModulo.show = false;

            _getConteudos();
        };

        let obj = {
            nome: modulo.nome,
            ordem: modulo.ordem || 1,
            idSessao: modulo.idSessao || $ctrl.selected.sessao,
            capaUrl: modulo.capaUrl || null,
            tipoModulo: modulo.tipoModulo || 'aulas',
            linkUrl: modulo.linkUrl || null,
            target: modulo.target || null
        };

        if(modulo.path){
            $fb.db.update(`${modulo.path}`, obj).then(()=>{
                __atualizaModulo();
            });

        }else{
            $fb.db.add(`${$ctrl.baseProduto.path}/modulos`, obj).then(()=>{
                __atualizaModulo();
            });
        }
    };

    const _deleteModulo=()=>{
        $fb.db.del(`${$ctrl.cfgModulo.dados.path}`).then(()=>{
            $toast.success($text.updateSuccess);

            $ctrl.cfgModulo.dados = {};
            $ctrl.cfgModulo.show = false;

            _getConteudos();
        }); 
    };
    
    const _confirmAula=(aula)=>{

        const __atualizaAula=()=>{
            $toast.success($text.updateSuccess);

            $ctrl.cfgAula.dados = {};
            $ctrl.cfgAula.show = false;

            _getAulas();
        };

        let modulo = $filter('filter')($ctrl.modulos, {id:$ctrl.selected.modulo})[0];

        if(!modulo){
            return;
        }

        let obj = {
            nome: aula.nome,
            ordem: aula.ordem || 1,
            tipo: aula.tipo || 'conteudo',
            liberacao: aula.liberacao || 0,
            conteudos: aula.conteudos || []
        };

        if(aula.path){
            $fb.db.update(`${aula.path}`, obj).then(()=>{
                __atualizaAula();
            });

        }else{
            $fb.db.add(`${modulo.path}/aulas`, obj).then(()=>{
                __atualizaAula();
            });
        }
    };

    const _deleteAula=()=>{
        $fb.db.del(`${$ctrl.cfgAula.dados.path}`).then(()=>{
            $toast.success($text.updateSuccess);

            $ctrl.cfgAula.dados = {};
            $ctrl.cfgAula.show = false;

            _getConteudos();
        });    
    };

    $ctrl.addModal=(modo)=>{
        if(modo === 'sessao'){
            $ctrl.editSessao({data:{ordem: $ctrl.sessoes.length+1}});
        }else if(modo === 'modulo'){
            $ctrl.editModulo({data:{idSessao: $ctrl.selected.sessao, ordem: $ctrl.modulos.length+1}});
        }else if(modo === 'aula'){
            $ctrl.editAula({data:{tipo:'conteudo', conteudos:[], ordem: $ctrl.aulas.length+1, liberacao:0}});
        }
    };

    $ctrl.editSessao=(sessao)=>{
        $ctrl.cfgSessao.dados = {...sessao.data, path: sessao.path};
        $ctrl.cfgSessao.show = true;
    };

    $ctrl.cfgSessao = {
        title: $text.session,
        show:false,
        isLoading:false,
        dados:{},
        confirm: _confirmSessao,
        delete: _deleteSessao
    };
    
    $ctrl.editModulo=(modulo)=>{
        $ctrl.cfgModulo.dados = {...modulo.data, path: modulo.path || false};
        $ctrl.cfgModulo.show = true;
    };

    $ctrl.cfgModulo = {
        title: $text.module,
        show:false,
        isLoading:false,
        dados:{},
        options:[],
        confirm: _confirmModulo,
        delete: _deleteModulo
    };
    
    $ctrl.editAula=(aula)=>{
        $ctrl.selected.aula = aula.id;

        $ctrl.cfgAula.dados = {...aula.data, path: aula.path};
        $ctrl.cfgAula.show = true;
    };

    $ctrl.cfgAula = {
        title: $text.lessons,
        show:false,
        isLoading:false,
        dados:{},
        confirm: _confirmAula,
        delete: _deleteAula
    };

    $ctrl.showAulas=()=>{
        return $ctrl.selected.modulo && $filter('filter')($ctrl.modulos, {id:$ctrl.selected.modulo})[0].data.tipoModulo === 'aulas';
    };

    $scope.$watch('$ctrl.selected.sessao', (newValue)=>{
        $ctrl.modFilter = { data:{ idSessao: $ctrl.selected.sessao } };
        $ctrl.selected.modulo = null;
    });
    
    $scope.$watch('$ctrl.selected.modulo', (newValue)=>{
        if(!!newValue){ _getAulas(); }
    });

    $ctrl.$onInit=()=>{
        _getConteudos();

    };

}]);